/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/game';
import { GAME } from '@/store/types';
import { finalizeAction, ActionType, StoreActionEnv } from '@/store/actions';
import { GameGroup } from '@/api/types/game';
import dailyModule, { StoreGameDailyState } from './daily';

export interface StoreGameState {
  filter?: string;
  games: GameGroup[];
  // modules
  daily: StoreGameDailyState;
}

export default {
  namespaced: true,
  modules: {
    daily: dailyModule,
  },
  state: {
    filter: null,
    games: null,
  },
  getters: {},
  actions: {
    [GAME.GET_GAMES](
      { state, commit }: StoreActionEnv<StoreGameState>,
      { action: rawAction, filter }: { action: ActionType; filter?: string } = { action: '' },
    ) {
      const action = finalizeAction(rawAction, state.filter === filter);
      if (action) {
        return new Promise<void>((resolve, reject) => {
          api.getGames(filter).then((res) => {
            commit(GAME.GET_GAMES, { filter, games: res.data });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [GAME.GET_GAMES](state: StoreGameState, { filter, games }) {
      state.filter = filter;
      state.games = games;
    },
  },
};
